import React, { useEffect, useState } from 'react'
import '../../../Assets/Css/AddAppreciation.scss'
import { customStyle } from '../../../Components/Style'
import Select from 'react-select'
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { connect } from 'react-redux'
import { toast } from 'react-toastify'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { Spinner } from 'react-bootstrap'
import DatePicker from 'react-datepicker';
import { IoClose, IoCloudUploadOutline } from 'react-icons/io5';
import { getUsers } from '../../../Services/Users/action';
import { addAppreciation, updateAppreciation, getAppreciations } from '../../../Services/Appreciation/action';
import { getAwards } from '../../../Services/Award/action';
import { getIconComponent } from '../../../Lib/utils';


const AddAppreciation = (props) => {
  const location = useLocation();
  const navigate = useNavigate();
  const data = location?.state?.data?.allData;
  const { employeeId } = useParams();

  useEffect(() => {
    const fetchData = async () => {
      await props?.getAwards();
      await props?.getUsers({ module: 'appreciation' });
      await props?.getAppreciations();
    }

    fetchData();
  }, [])

  const EmployeeList = props?.users?.map(user => {
    return {
      value: user?.id,
      label: user?.name
    }
  });

  const AwardType = props?.award?.filter((item) => item?.status === 'Active')?.map((item) => {
    return {
      value: item?.id,
      label: item?.title,
      icon: getIconComponent(item?.icon),
      bgColor: item?.icon_background_color || "#eee"
    }
  });

  const formatOptionLabel = ({ label, icon: Icon, bgColor }) => (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <div
        style={{
          backgroundColor: bgColor,
          width: 32,
          height: 32,
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#fff',
          marginRight: 10,
          fontSize: 16
        }}
      >
        {Icon && <Icon />}
      </div>
      <span>{label}</span>
    </div>
  );

  const initialState = {
    title: data ? AwardType?.find(item => item?.value == data?.award_id) : null,
    givenTo: data ? EmployeeList?.find(item => item?.value == data?.given_to_employeeId) : EmployeeList?.find(item => item?.value == employeeId),
    date: data?.date || null,
    notes: data?.summary || null,
  }
  const [clientData, setClientData] = useState(initialState);

  const validateDuplicateAward = () => {
    const allAppreciations = props?.appreciation || [];
    const existingAppreciation = allAppreciations?.find(item => {

      const itemDate = item?.date ? item.date.split(' ')[0] : item?.date;
      const selectedDate = clientData?.date;

      const isDuplicate = (
        item?.award_id == clientData?.title?.value &&
        item?.given_to_employeeId == clientData?.givenTo?.value &&
        itemDate === selectedDate &&
        (!data || item?.id != data?.id)
      );
      return isDuplicate;
    });

    return !existingAppreciation;
  };
  const handleAddUpdateAppreciation = async () => {
    const { title, givenTo, date } = clientData;
    if (!title || !givenTo || !date) {
      toast.error("Please fill all required fields!");
      return;
    }
    if (!validateDuplicateAward()) {
      toast.error("This award was already given to the employee on this date.");
      return;
    }
    try {
      const body = {
        award_id: clientData?.title?.value,
        given_to_employeeId: clientData?.givenTo?.value,
        date: clientData?.date,
        summary: clientData?.notes,
      }
      if (data) {
        await props?.updateAppreciation(data?.id, body);
      }
      else {
        await props?.addAppreciation(body);
      }
      navigate(-1)
    } catch (error) {
      console.error("Error in handle add/update appreciation:", error)
    }
  }

  return (
    <div className="addAppreciation-main">
      <div className="page-title">
        <h4> {data ? "Update" : "Add"} Appreciation</h4>
        <div className="edit-btn">
          <button
            type="submit"
            className="custom-btn"
            onClick={() => navigate(-1)}
          >Cancel</button>

          <button
            type="submit"
            className="custom-btn"
            onClick={handleAddUpdateAppreciation}
          >
            {props.loading ? (
              <Spinner
                as="span"
                animation="border"
                className="custom-spinner"
                role="status"
                aria-hidden="true"
              />
            ) : (
              'Save'
            )}
          </button>
        </div>
      </div>

      <div className="content-part">
        <div className="row">
          <div className="col-lg-12">
            <div className="left-part">
              <div className="custom-row">
                <div className='add-appreciation-detail'>
                  <div className="row">
                    <div className="col-lg-4">
                      <div className="input-group">
                        <h6 className='label'>Award <span className='required-field'> *</span></h6>
                        <Select
                          options={AwardType}
                          styles={{
                            ...customStyle,
                            menu: (provided) => ({
                              ...provided,
                              zIndex: 2,
                            }),
                          }}
                          value={clientData.title}
                          placeholder="---"
                          onChange={(val) => {
                            setClientData((preVal) => ({
                              ...preVal,
                              title: val
                            }))
                          }}
                          theme={(theme) => ({
                            ...theme,
                            colors: {
                              ...theme.colors,
                              primary25: "#5757fe",
                              primary: "#5757fe",
                            },
                          })}
                          formatOptionLabel={formatOptionLabel}
                          isClearable
                        />
                      </div>
                    </div>
                    <div className="col-lg-4">
                      <div className="input-group">
                        <h6 className='label'>Given To <span className='required-field'> *</span></h6>
                        <Select
                          options={EmployeeList}
                          styles={{
                            ...customStyle,
                            menu: (provided) => ({
                              ...provided,
                              zIndex: 2,
                            }),
                          }}
                          isDisabled={clientData?.givenTo ? true : false}
                          value={clientData.givenTo}
                          placeholder="---"
                          onChange={(val) => {
                            setClientData((preVal) => ({
                              ...preVal,
                              givenTo: val
                            }))
                          }}
                          theme={(theme) => ({
                            ...theme,
                            colors: {
                              ...theme.colors,
                              primary25: "#5757fe",
                              primary: "#5757fe",
                            },
                          })}
                        />
                      </div>
                    </div>
                    <div className="col-lg-4">
                      <div className="input-group">
                        <h6 className='label'>Date <span className='required-field'> *</span></h6>
                        <DatePicker
                          selected={clientData.date ? new Date(clientData.date) : null}
                          onChange={(date) => {
                            const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000)
                              .toISOString()
                              .split('T')[0];
                            setClientData((preVal) => ({
                              ...preVal,
                              date: localDate,
                            }));
                          }}
                          dateFormat="dd-MM-yyyy"
                          placeholderText="Date"
                          name="transaction_date"
                          disabled={props.loading}
                          customInput={<input className="input-css" />}
                          theme={(theme) => ({
                            ...theme,
                            colors: {
                              ...theme.colors,
                              primary25: "#5757fe",
                              primary: "#5757fe",
                            },
                          })}
                        />
                      </div>
                    </div>

                    <div className="col-lg-12">
                      <div className="note-part">
                        <h6 className="label">Summary</h6>
                        <div className="editor-custom">
                          <CKEditor
                            editor={ClassicEditor}
                            data={clientData?.notes || ""}
                            onReady={editor => {
                              console.log('Editor is ready to use!', editor);
                            }}
                            onChange={(event, editor) => {
                              const data = editor.getData();
                              console.log({ event, editor, data });
                              setClientData((preVal) => ({
                                ...preVal,
                                notes: data
                              }))
                            }}
                            onBlur={(event, editor) => {
                              console.log('Blur.', editor);
                            }}
                            onFocus={(event, editor) => {
                              console.log('Focus.', editor);
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
const mapStateToProps = (state) => {
  return {
    loading: state.clientsReducer.loading,
    users: state.userReducer.users,
    award: state.awardReducer.award,
    appreciation: state.appreciationReducer.appreciation
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getUsers: (options) => {
      dispatch(getUsers(options));
    },
    getAwards: () => {
      dispatch(getAwards())
    },
    getAppreciations: () => {
      dispatch(getAppreciations())
    },
    addAppreciation: (data) => {
      dispatch(addAppreciation(data))
    },
    updateAppreciation: (id, data) => {
      dispatch(updateAppreciation(id, data))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AddAppreciation);